import { Pixelation, EffectComposer } from "@react-three/postprocessing";

import React from "react";

export type LoadingProps = {
  isLoading: boolean;
  progress?: string; // in the future we could control the effect by progress (e.g it gets less pixelated as it loads 😉)
};

const DynamicPixelationLoader: React.FC<LoadingProps> = ({ isLoading }) =>
  isLoading ? (
    <EffectComposer>
      <Pixelation granularity={10} />
    </EffectComposer>
  ) : null;

export default DynamicPixelationLoader;
